import { motion } from "framer-motion";
import { SecondaryButton2 } from "./sections/Buttons";
import { Link } from "react-router-dom";

const DevelopmentalBehaviorTherapyPage = () => (
  <motion.div
    className="bg-white"
    initial={{ opacity: 0, y: 30 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -30 }}
    transition={{ duration: 0.5, ease: "easeInOut" }}
  >
    {/* Hero Section */}
    <section className="bg-purple-800 relative overflow-hidden py-20 text-center">
      <div className="absolute inset-0 p-4 flex items-center justify-center pointer-events-none">
        <svg
          width="900"
          height="400"
          viewBox="0 0 900 400"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-full h-full opacity-20"
        >
          <circle cx="450" cy="200" r="200" fill="#fff" fillOpacity="0.07" />
          <circle cx="450" cy="200" r="300" fill="#fff" fillOpacity="0.04" />
        </svg>
      </div>
      <div className="relative z-10">
        <h1 className="text-5xl font-extrabold mb-2 text-white drop-shadow">
          Social Skills <br></br>Development Programs
        </h1>
        <div className="text-2xl text-white font-semibold mb-4">
          At Spectrum Nurturing Academy
        </div>
      </div>
    </section>

    {/* Info Card Section */}
    <section className="relative py-16 flex justify-center items-center bg-white">
      <div className="max-w-xl w-full bg-white rounded-xl shadow-2xl p-8 z-10">



        <p className="text-gray-800 text-base mb-4">Social interactions don’t always come naturally for children with developmental challenges. Our Social Skills Programsare designed to:</p>

        <ul className="list-disc pl-6 text-gray-800 text-base space-y-3 mb-4">
          <li>Teach turn-taking, sharing, and cooperative play.</li>
  <li>Build friendships and peer relationships.</li>
  <li>Improve conversation and perspective-taking.</li>
  <li>Address emotional regulation and self-awareness.</li>
  <li>Use role-play, group games, and structured peer interaction.</li>
        </ul>



        <p className="text-gray-800 text-base mb-0">
          Sessions are small-group based and age-appropriate, led by trained therapists using proven techniques like Social Stories™ and peer modeling.</p>

      </div>
    </section>

    {/* CTA Section */}
    <section className="flex justify-center items-center py-20 px-2 bg-white">
      <div className="w-full max-w-3xl mx-auto rounded-2xl shadow-xl bg-gradient-to-r from-orange-400 to-pink-400 p-12 text-center">
        <h2 className="text-3xl font-extrabold text-white mb-4">
          Come Visit Us
        </h2>
        <p className="text-white mb-8 text-lg font-medium">
          Contact us today to schedule a free evaluation and tour. Our dedicated
          team is ready to help your child succeed.
        </p>
     
         <div className="flex justify-center mt-6">
          <Link to="/contact">
          <SecondaryButton2
            label="CONTACT US"
            colorClass="text-white bg-black hover:bg-black-500"
          />
        </Link>
        </div>
      </div>
    </section>
  </motion.div>
);

export default DevelopmentalBehaviorTherapyPage;
